import type { ReactNode } from "react";
import type { ScopeKind } from "../../../../shared/rbac/permissions";
import { Button } from "../../Button";
import { Modal } from "../../Modal";
import { Text } from "../../Text";
import {
  ColoredIconBadge,
  ModalBody,
  ModalHeader,
  ModalHeaderRight,
} from "../shared";
import { SCOPE_ICONS } from "./constants";

type Props = {
  open: boolean;
  onClose: () => void;
  scopeKind: ScopeKind;
  title: ReactNode;
  titleExtra?: ReactNode;
  footer: ReactNode;
  children: ReactNode;
};

export function ModalContainer({
  open,
  onClose,
  scopeKind,
  title,
  titleExtra,
  footer,
  children,
}: Props) {
  return (
    <Modal
      open={open}
      onClose={onClose}
      style={{
        width: 680,
        height: 760,
        display: "flex",
        flexDirection: "column",
      }}
    >
      <ModalHeader>
        <ColoredIconBadge id={scopeKind} iconName={SCOPE_ICONS[scopeKind]} />
        <div
          style={{ display: "flex", alignItems: "center", gap: 6, minWidth: 0 }}
        >
          <Text variant="text-regular-md">{title}</Text>
          {titleExtra}
        </div>
        <ModalHeaderRight>
          <Button size="l" variant="secondary" icon="x" onClick={onClose} />
        </ModalHeaderRight>
      </ModalHeader>
      <ModalBody>{children}</ModalBody>
      {footer}
    </Modal>
  );
}
